import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Trash2, RefreshCw, Check, Mail, Phone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistTab = ({ pin }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/waitlist/list`, { pin });
      setItems(data);
    } catch { toast.error("Warteliste konnte nicht geladen werden"); }
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const toggleContacted = async (id, contacted) => {
    try {
      await axios.patch(`${API}/admin/waitlist/${id}`, { pin, contacted: !contacted });
      load();
    } catch { toast.error("Speichern fehlgeschlagen"); }
  };

  const del = async (id) => {
    if (!window.confirm("Eintrag löschen?")) return;
    try {
      await axios.delete(`${API}/admin/waitlist/${id}?pin=${pin}`);
      toast.success("Eintrag gelöscht");
      load();
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const fmtDate = (iso) => {
    try { return new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "short", year: "numeric" }); }
    catch { return iso; }
  };

  return (
    <div data-testid="tab-waitlist" className="max-w-5xl">
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <div>
          <h3 className="font-serif text-2xl">Warteliste</h3>
          <p className="text-sm text-muted-foreground mt-1">Alle Kundinnen, die sich für einen Wunschtermin eingetragen haben.</p>
        </div>
        <button data-testid="waitlist-refresh" onClick={load} className="group flex items-center gap-2 text-sm text-foreground/70 hover:text-foreground">
          <RefreshCw size={14} className="group-hover:rotate-180 transition-transform duration-500" /> Aktualisieren
        </button>
      </div>

      <div className="border border-border">
        <div className="grid grid-cols-[1fr_1.4fr_1fr_1.2fr_100px_60px] gap-3 px-4 py-2.5 border-b border-border bg-muted text-[10px] uppercase tracking-widest text-muted-foreground">
          <div>Eingetragen</div>
          <div>Name & Kontakt</div>
          <div>Handy</div>
          <div>Dienstleistung</div>
          <div>Kontaktiert</div>
          <div></div>
        </div>
        {items.map((w) => (
          <div key={w.id} data-testid={`waitlist-row-${w.id}`} className="grid grid-cols-[1fr_1.4fr_1fr_1.2fr_100px_60px] gap-3 px-4 py-3 border-b border-border items-center text-sm">
            <div className="text-xs text-muted-foreground">{fmtDate(w.created_at)}</div>
            <div>
              <div className="font-medium">{w.first_name} {w.last_name}</div>
              <a href={`mailto:${w.email}`} className="inline-flex items-center gap-1 text-xs text-primary hover:underline"><Mail size={11}/> {w.email}</a>
              {w.notes && <div className="text-[11px] text-muted-foreground mt-1 italic">„{w.notes}"</div>}
            </div>
            <a href={`tel:${w.phone}`} className="inline-flex items-center gap-1 text-xs hover:text-primary"><Phone size={12}/> {w.phone}</a>
            <div className="text-xs">{w.service}</div>
            <button
              type="button"
              data-testid={`waitlist-toggle-${w.id}`}
              onClick={() => toggleContacted(w.id, w.contacted)}
              className={`h-8 px-2 border text-xs flex items-center justify-center gap-1 transition-colors ${w.contacted ? "bg-primary text-primary-foreground border-primary" : "border-border text-foreground/60 hover:border-primary"}`}
              title={w.contacted ? "Als offen markieren" : "Als kontaktiert markieren"}
            >
              <Check size={12} /> {w.contacted ? "erledigt" : "offen"}
            </button>
            <button onClick={() => del(w.id)} className="text-foreground/40 hover:text-red-600 h-8 flex items-center justify-center" title="Löschen">
              <Trash2 size={14} />
            </button>
          </div>
        ))}
        {!items.length && !loading && (
          <p className="p-6 text-center text-sm text-muted-foreground">Noch keine Einträge auf der Warteliste.</p>
        )}
      </div>
    </div>
  );
};
